const nextPath = (currentPath: string | number, nextKey: string | number) =>
  currentPath ? `${currentPath}.${nextKey}` : nextKey

const recursivelyDeleteKeys = (
  obj: object | Array<object>,
  keys: string[],
  seenObjects: Map<any, any>,
  currentPath: string | number
) => {
  if (!obj || typeof obj !== 'object') {
    return obj
  }

  if (seenObjects.has(obj)) {
    return `[CIRCULAR_REF] path=${seenObjects.get(obj)}`
  }

  seenObjects.set(obj, currentPath)

  if (Array.isArray(obj)) {
    obj = [...obj]
    for (let i = 0, len = (obj as Array<object | object[]>).length; i < len; i++) {
      // @ts-expect-error - ignore type issue
      obj[i] = recursivelyDeleteKeys(
        // @ts-expect-error - ignore type issue
        obj[i],
        keys,
        seenObjects,
        nextPath(currentPath, i)
      )
    }
  } else {
    const objectKeys = Object.keys(obj)
    obj = { ...obj }

    for (let i = 0, len = objectKeys.length; i < len; i++) {
      const objectKey = objectKeys[i]
      if (keys.indexOf(objectKey) >= 0) {
        // @ts-expect-error - ignore type issue
        delete obj[objectKey]
      } else {
        // @ts-expect-error - ignore type issue
        obj[objectKey] = recursivelyDeleteKeys(
          // @ts-expect-error - ignore type issue
          obj[objectKey],
          keys,
          seenObjects,
          nextPath(currentPath, objectKey)
        )
      }
    }
  }
  return obj
}

export const deepDelete = (obj: object | Array<object>, keysToDelete: string[]) =>
  recursivelyDeleteKeys(obj, keysToDelete, new Map(), '')
